"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useBillingAddress = void 0;
var _auth = require("@ori/auth");
var _checkoutDelivery = require("@ori/checkout-delivery");
var _checkoutUtils = require("@ori/checkout-utils");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _shoppingContext = require("@ori/shopping-context");
var _contexts = require("../../contexts");
var _logger = require("../../logger");
function handleCallbackError(param) {
    let { httpStatus } = param;
    (0, _checkoutUtils.showErrorNotification)();
    const description = "HTTP status code: ".concat(httpStatus === undefined ? 'unknown' : httpStatus.toString());
    const error = new Error('Error while working with address data.');
    const childLogger = _logger.mainLogger.createChild('handleCallbackError');
    childLogger.error(error, {
        description
    });
}
const useBillingAddress = ()=>{
    const { formattedToken } = (0, _auth.useToken)();
    const { mutateCustomerCheckoutPrerequisites } = (0, _contexts.useNavigationContext)();
    const { isLoaded, isLoading, shoppingContext: { customerId = _auth.NOT_LOGGED_IN_USER_ID, isDeliveryChannelSelected = false, shoppingBagOwnerName = '' } = {} } = (0, _shoppingContext.useShoppingContext)();
    const { data: { customerAddressesCollection = [] } = {}, mutate: mutateCustomerAddresses, isValidating: areCustomerAddressesLoading } = (0, _globalApiClientReact.useGetCustomerAddresses)(customerId, {}, undefined, {
        swr: {
            enabled: isDeliveryChannelSelected,
            ..._checkoutUtils.errorHandlingSwrOptions
        }
    });
    const handleAddressFormCallbackData = (data)=>{
        (0, _logger.logDebug)('handleAddressFormCallbackData() called.\n\tCurrent form data:', data);
        void mutateCustomerAddresses();
        void mutateCustomerCheckoutPrerequisites();
    };
    const handleBillingAddressRefresh = ()=>{
        (0, _logger.logDebug)('handleBillingAddressRefresh() called.');
        void mutateCustomerAddresses();
        void mutateCustomerCheckoutPrerequisites();
    };
    const billingAddress = customerAddressesCollection.find((customerAddress)=>customerAddress.isBilling);
    const isShoppingContextLoading = isLoading && !isLoaded;
    const isQueryLoading = isShoppingContextLoading || areCustomerAddressesLoading;
    // create address-form properties
    const addressFormProps = {
        appConfiguration: {
            processContext: _checkoutDelivery.processContext,
            formattedToken
        },
        customerId,
        configForm: {
            hideActionButtons: false,
            isDialog: false
        },
        handleCallbackData: handleAddressFormCallbackData,
        handleCallbackError
    };
    return {
        billingAddressContentProps: {
            addressFormProps,
            billingAddress,
            shoppingBagOwnerName
        },
        handleBillingAddressRefresh,
        isDeliveryChannelSelected,
        isQueryLoading
    };
};
exports.useBillingAddress = useBillingAddress;
